import { Card, Progress, Segmented } from "antd";
import React, { useRef, useState } from "react";
import Icon from "../../../assets/Icon";

function InterviewAnalysisSecondSec({
  videoRef,
  interviewAnalysisData,
  currentTime,
  updateVideoTrack,
  analysisData,
  interviewAnalysisDataConfig,
}) {
  const [recordinState, setRecordingState] = useState(
    "Candidate Video Recording"
  );
  const [currentAnalysis, setCurrentAnalysis] = useState(null);

  const handleTimeUpdate = (event) => {
    let currentTimeUpdate = event?.target?.currentTime;

    // Convert the keys of analysisData to numbers, find the closest one
    if (analysisData) {
      const times = Object.keys(analysisData)?.map((time) => parseFloat(time));
      const closestTime = times?.reduce((prev, curr) =>
        Math.abs(curr - currentTimeUpdate) < Math.abs(prev - currentTimeUpdate)
          ? curr
          : prev
      );

      setCurrentAnalysis(analysisData[closestTime]);
    }
  };
  const handleSourceChange = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = currentTime;
    }
  };
  return (
    <div className="mt-8">
      <div className="analysis-segment">
        <Segmented
          options={["Candidate Video Recording", "Candidate Screen Recording"]}
          defaultValue={recordinState}
          onChange={(value) => {
            setRecordingState(value);
            setCurrentAnalysis(null);
            videoRef.current?.currentTime &&
              updateVideoTrack(videoRef.current.currentTime);
          }}
          size="large"
        />
      </div>

      <div className="lg:flex inline-block justify-between gap-4 mt-6 lg:h-[480px] w-full">
        <div className=" lg:w-[60%] w-full bg-gray-300 rounded-lg shadow-xl text-center flex items-center" >
          {recordinState === "Candidate Video Recording" ? (
            interviewAnalysisDataConfig?.configuration
              ?.videoRecordingRequired ? (
              <video
                controls
                ref={videoRef}
                src={interviewAnalysisData?.candidateVideoUrl}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
                onTimeUpdate={handleTimeUpdate}
                className="rounded-lg shadow-lg"
                onLoadedMetadata={handleSourceChange}
              />
            ) : (
              <div className="m-auto py-10 px-4">
                <p className="text-center flex justify-center">
                  <Icon type="lock-orientation-icon" width="58" height="58" />
                </p>
                <p className=" text-[#475467] text-center mt-[.6rem]">
                  Upgrade/Enable to unlock all video recording premium features.
                </p>
                <div className="text-[#475467] text-center mt-[.1rem]">
                  Contact{" "}
                  <a
                    href="mailto:support@hireplusplus.com"
                    className="text-[#206DC5] hover:text-blue-400 font-medium"
                  >
                    support@hireplusplus.com
                  </a>{" "}
                  to Upgrade/Enable.
                </div>
              </div>
            )
          ) : interviewAnalysisDataConfig?.configuration
              ?.screenRecordingRequired ? (
            <video
              controls
              ref={videoRef}
              src={interviewAnalysisData?.screenVideoUrl}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              onTimeUpdate={handleTimeUpdate}
              className="rounded-lg shadow-lg"
              onLoadedMetadata={handleSourceChange}
            />
          ) : (
            <div className="m-auto py-10 px-4">
              <p className="text-center flex justify-center">
                <Icon type="lock-orientation-icon" width="58" height="58" />
              </p>
              <p className=" text-[#475467] text-center mt-2">
                Upgrade/Enable to unlock all screen recording premium features.
              </p>
              <div className="text-[#475467] text-center mt-[.1rem]">
                Contact{" "}
                <a
                  href="mailto:support@hireplusplus.com"
                  className="text-[#206DC5] hover:text-blue-400 font-medium"
                >
                  support@hireplusplus.com
                </a>{" "}
                to Upgrade/Enable.
              </div>
            </div>
          )}
        </div>
        <div className="lg:w-[38%] w-full grid grid-cols-1 lg:grid-cols-1 md:grid-cols-2  gap-2 lg:mt-0 mt-3 ">
          <Card className="w-full border-[#D0D5DD] border shadow-md">
            <div className="flex items-center gap-4">
              <p className="inline-block p-2 rounded-lg bg-[#206DC5]   ">
                {" "}
                <Icon type="head-orientation-icon" width="28" height="20" />
              </p>
              <span className="text-[1.08rem] text-[#101828] font-semibold">
                Head Orientation
              </span>
            </div>
            {/* <div className="mt-4 flex justify-between"> */}
            {interviewAnalysisDataConfig?.configuration
              ?.videoRecordingRequired &&
            interviewAnalysisDataConfig?.configuration
              ?.headPoseDetectionRequired ? (
              <div className="mt-4 flex justify-between">
                <div className="">
                  <p className="font-semibold text-[.95rem] text-[#101828]">
                    Left/Right
                  </p>
                  <p
                    className={`${
                      currentAnalysis?.headRightLeftOrientation?.analysis.toLowerCase() ===
                        "no face detected" ||
                      currentAnalysis?.headRightLeftOrientation?.analysis.toLowerCase() ===
                        "multiple faces detected"
                        ? "text-red-500"
                        : "text-[#206DC5]"
                    } text-[1.2rem] font-semibold max-w-[160px] break-words leading-[1.55rem] mt-1`}
                  >
                    {currentAnalysis?.headRightLeftOrientation?.analysis}
                  </p>

                  <p className="font-semibold mt-1">
                    {currentAnalysis?.headRightLeftOrientation?.value.toFixed(
                      1
                    )}
                    °
                  </p>
                </div>
                <div>
                  <p className="font-semibold text-[.95rem] text-[#101828]">
                    Up/Down
                  </p>
                  <p
                    className={`${
                      currentAnalysis?.headUpDownOrientation?.analysis.toLowerCase() ===
                        "no face detected" ||
                      currentAnalysis?.headUpDownOrientation?.analysis.toLowerCase() ===
                        "multiple faces detected"
                        ? "text-red-500"
                        : "text-[#206DC5]"
                    } text-[1.2rem] font-semibold max-w-[160px] break-words leading-[1.55rem] mt-1`}
                  >
                    {currentAnalysis?.headUpDownOrientation?.analysis}
                  </p>
                  <p className="font-semibold mt-1">
                    {currentAnalysis?.headUpDownOrientation?.value.toFixed(1)}°
                  </p>
                </div>
              </div>
            ) : (
              <div className="mt-1">
                <p className="text-center flex justify-center">
                  <Icon type="lock-orientation-icon" width="36" height="36" />
                </p>
                <p className=" text-[#475467] text-center mt-1">
                  Upgrade/Enable to unlock head orientation features.
                </p>
              </div>
            )}
            {/* </div> */}
          </Card>
          <Card className="w-full border-[#D0D5DD] border shadow-md">
            <div className="flex justify-between gap-3 flex-wrap lg:flex-nowrap">
              <div className="w-[50%] flex items-center gap-4 ">
                <p className="inline-block p-2 rounded-lg bg-[#206DC5]   ">
                  {" "}
                  <Icon type="pupil-orientation-icon" width="28" height="20" />
                  {/* hello */}
                </p>
                <span className="text-[1.08rem] text-[#101828] leading-[1.55rem] font-semibold">
                  Pupil Orientation
                </span>
              </div>
              {interviewAnalysisDataConfig?.configuration
                ?.videoRecordingRequired &&
              interviewAnalysisDataConfig?.configuration
                ?.gazeDetectionRequired ? (
                <div className="flex-1 flex justify-center lg:justify-end gap-[.9rem] items-center">
                  <div className="">
                    <Progress
                      type="circle"
                      percent={currentAnalysis?.pupilOrientation?.value?.toFixed(
                        1
                      )}
                      strokeWidth={10}
                      strokeColor="#1890ff"
                      size={80}
                      format={(percent) => (
                        <span className="text-[1.08rem] text-[#101828] font-medium">
                          {percent === 100 ? "100%" : `${percent}%`}
                        </span>
                      )}
                    />
                  </div>
                  <p
                    className={`${
                      currentAnalysis?.pupilOrientation?.analysis.toLowerCase() ===
                        "no face detected" ||
                      currentAnalysis?.pupilOrientation?.analysis.toLowerCase() ===
                        "multiple faces detected"
                        ? "text-red-500"
                        : "text-[#475467]"
                    } font-semibold text-[1.08rem] w-[82px] break-words leading-[1.45rem]`}
                  >
                    {" "}
                    {currentAnalysis?.pupilOrientation?.analysis}
                  </p>
                </div>
              ) : (
                <div className="mx-auto">
                  <p className="text-center flex justify-center">
                    <Icon type="lock-orientation-icon" width="36" height="36" />
                  </p>
                  <p className=" text-[#475467] text-center mt-1 leading-[1.25rem]">
                    Upgrade/Enable to unlock pupil orientation features.
                  </p>
                </div>
              )}
            </div>
          </Card>
          <Card className="w-full border-[#D0D5DD] border shadow-md md:col-span-2 lg:col-span-1 col-span-1">
            {interviewAnalysisDataConfig?.configuration
              ?.videoRecordingRequired &&
            interviewAnalysisDataConfig?.configuration
              ?.emotionAnalysisRequired ? (
              <div className=" flex justify-between gap-3 flex-wrap lg:flex-nowrap">
                <div className="flex w-[50%] items-center gap-4 ">
                  <p className="inline-block p-2 rounded-lg bg-[#206DC5]   ">
                    {" "}
                    <Icon
                      type="dominant-orientation-icon"
                      width="28"
                      height="20"
                    />
                    {/* hello */}
                  </p>
                  <span className="text-[1.08rem] text-[#101828] font-semibold">
                    Dominant Emotion
                  </span>
                </div>
                <div className="flex-1 flex justify-center lg:justify-end gap-[.9rem] items-center">
                  <div className="">
                    {" "}
                    <Progress
                      type="circle"
                      percent={currentAnalysis?.dominantEmotion?.value?.toFixed(
                        1
                      )}
                      strokeWidth={10}
                      size={80}
                      strokeColor="#F79009"
                      format={(percent) => (
                        <span className="text-[1.08rem] text-[#101828] font-medium">
                          {percent === 100 ? "100%" : `${percent}%`}
                        </span>
                      )}
                    />
                  </div>
                  <p
                    className={`${
                      currentAnalysis?.dominantEmotion?.analysis.toLowerCase() ===
                        "no face detected" ||
                      currentAnalysis?.dominantEmotion?.analysis.toLowerCase() ===
                        "multiple faces detected"
                        ? "text-red-500"
                        : "text-[#475467]"
                    } font-semibold text-[1.08rem] w-[82px] break-words leading-[1.45rem]`}
                  >
                    {currentAnalysis?.dominantEmotion?.analysis}
                  </p>
                </div>
              </div>
            ) : (
              <div className="flex flex-col lg:flex-row gap-3">
                <div className="flex items-center gap-4 ">
                  <p className="inline-block p-2 rounded-lg bg-[#206DC5]   ">
                    <Icon
                      type="dominant-orientation-icon"
                      width="28"
                      height="20"
                    />
                  </p>
                  <span className="text-lg text-[#101828] font-semibold leading-[1.55rem]">
                    Dominant Emotion
                  </span>
                </div>
                <div className="mt-1">
                  <p className="text-center flex justify-center">
                    <Icon type="lock-orientation-icon" width="36" height="36" />
                  </p>
                  <p className=" text-[#475467] text-center mt-1 leading-[1.25rem]">
                    Upgrade/Enable to unlock dominant emotion features.
                  </p>
                </div>
              </div>
            )}
          </Card>
        </div>
      </div>
    </div>
  );
}

export default InterviewAnalysisSecondSec;
